const actions = {
  SET_STATE: 'questions/SET_STATE',
  GET_DATA: 'questions/GET_DATA',
}

export default actions
